import axios from "../request";

//获取商家栏目列表
export function getCategory(data) {
  return axios.request({
    url: "api/Category",
    method: "get",
    params: data,
  });
}
//新增商家栏目
export function addCategory(data) {
  return axios.request({
    url: "api/Category",
    method: "post",
    data: data
  });
}

//删除商家栏目
export function delCategory(id) {
  return axios.request({
    url: "api/Category/"+id,
    method: "delete"
  });
}

//修改商家栏目
export function updateCategory(id, data) {
  return axios.request({
    url: "api/Category/"+id,
    method: "put",
    data: data
  });
}
